var filterButton = document.querySelectorAll('.vip-filter__trigger');
var filterDropdown = document.querySelectorAll('.vip-filter__dropdown');
var filterElements = document.querySelectorAll('.vip-filter');

filterButton.forEach(button => {
    button.addEventListener('click', () =>{
    
        if(button.nextElementSibling.classList.contains('active')){
            button.nextElementSibling.classList.remove('active');
        }
        else{
            filterDropdown.forEach(dropdown =>{
                dropdown.classList.remove('active');
            })
            button.nextElementSibling.classList.add('active');
        }
    })
})

window.addEventListener('click', function(e){  

    if(!e.target.closest('.vip-filter')){
        filterDropdown.forEach(dropdown =>{
            dropdown.classList.remove('active');
        })
    }

  })
